import React from "react";

function SkeletonBlock({ className = "" }) {
  return (
    <div
      className={`animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10 ${className}`}
    />
  );
}

function PassageGradeSkeleton() {
  return (
    <div className="grid gap-5 lg:grid-cols-[1.35fr_0.65fr]">
      <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
        <SkeletonBlock className="h-8 w-56" />

        <div className="mt-6 space-y-4">
          <SkeletonBlock className="h-32" />
          <SkeletonBlock className="h-32" />
          <SkeletonBlock className="h-32" />
        </div>
      </div>

      <div className="space-y-5">
        <SkeletonBlock className="h-72" />
        <SkeletonBlock className="h-80" />
      </div>
    </div>
  );
}

export default PassageGradeSkeleton;